<template>
  <div class="upload-view">
    <div class="upload-toolbar">
      <span class="upload-toolbar-label">产品上传</span>
      <button class="clear-task-btn" @click="onClearTask">清空任务</button>
    </div>

    <div class="product-type-banner" role="group" aria-label="商品类型选择">
      <div class="banner-stripe"></div>
      <div class="banner-body">
        <div class="banner-header">
          <span class="banner-tag">重要</span>
          <span class="banner-title">商品类型</span>
          <span class="banner-desc">选错会导致生成结果不符合预期</span>
        </div>
        <div class="type-cards">
          <button
            type="button"
            class="type-card"
            :class="{ active: workbench.isWomenClothing }"
            @click="workbench.setIsWomenClothing(true)"
          >
            <span class="type-card-radio"></span>
            <span class="type-card-name">女装</span>
          </button>
          <button
            type="button"
            class="type-card"
            :class="{ active: !workbench.isWomenClothing }"
            @click="workbench.setIsWomenClothing(false)"
          >
            <span class="type-card-radio"></span>
            <span class="type-card-name">通用商品</span>
          </button>
        </div>
      </div>
    </div>

    <div v-for="(product, idx) in workbench.products" :key="product.id" class="product-row-wrapper">
      <ProductRow :product="product" :productIndex="idx" />
    </div>
  </div>
</template>

<script setup>
import { useWorkbenchStore } from '@/stores/useWorkbenchStore'
import ProductRow from '@/components/upload/ProductRow.vue'

const workbench = useWorkbenchStore()

const onClearTask = () => {
  if (!confirm('确定要清空当前任务吗？\n\n所有产品（A/B/C）的上传图片都会被删除，且无法恢复。')) return
  workbench.clearAllTask()
}
</script>

<style scoped>
.upload-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px 12px;
  gap: 1rem;
  flex-wrap: wrap;
}
.upload-toolbar-label {
  font-size: 15px;
  font-weight: 600;
  color: #1d2129;
}
.clear-task-btn {
  border: 1px solid #d9d9d9;
  background: #fff;
  color: #333;
  border-radius: 6px;
  padding: 0.4rem 1rem;
  font-size: 0.85rem;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}
.clear-task-btn:hover {
  border-color: #c99658;
  color: #c99658;
}

/* 商品类型横幅 */
.product-type-banner {
  position: relative;
  display: flex;
  margin: 0 24px 16px;
  background: #fff9f0;
  border: 1px solid #e8d4b0;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(201, 150, 88, 0.08);
}
.banner-stripe {
  flex-shrink: 0;
  width: 4px;
  background: linear-gradient(180deg, #d9a85a 0%, #c99658 100%);
}
.banner-body {
  flex: 1;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}
.banner-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.banner-tag {
  display: inline-flex;
  align-items: center;
  padding: 1px 7px;
  background: #c99658;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  border-radius: 4px;
  letter-spacing: 0.04em;
}
.banner-title {
  font-size: 14px;
  font-weight: 700;
  color: #5a3d1a;
}
.banner-desc {
  font-size: 12.5px;
  color: #8c6d3f;
}

.type-cards {
  display: inline-flex;
  gap: 8px;
  margin-left: auto;
}
.type-card {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 6px 14px;
  background: #fff;
  border: 1.5px solid #e5dfd3;
  border-radius: 8px;
  cursor: pointer;
  font-family: inherit;
  font-size: 13.5px;
  font-weight: 600;
  color: #6b5d44;
  transition: all 0.15s ease;
}
.type-card:hover {
  border-color: #c99658;
  background: #fffdf9;
}
.type-card.active {
  border-color: #c99658;
  background: #fff4e0;
  color: #5a3d1a;
  box-shadow: 0 2px 6px rgba(201, 150, 88, 0.18);
}
.type-card-radio {
  flex-shrink: 0;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  border: 2px solid #c9bda5;
  background: #fff;
  position: relative;
  transition: all 0.15s ease;
}
.type-card.active .type-card-radio {
  border-color: #c99658;
}
.type-card.active .type-card-radio::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #c99658;
}

@media (max-width: 720px) {
  .type-cards {
    margin-left: 0;
    width: 100%;
  }
}
</style>
